/**
 * Paleta padrão do Daily Prebuilt (tema escuro).
 * @see https://docs.daily.co/guides/products/prebuilt/customizing-daily-prebuilt-calls-with-color-themes
 */
export const SESSION_CALL_DAILY_DARK_THEME = {
	accent: '#60A5FA',
	accentText: '#0F172A',
	background: '#0F172A',
	backgroundAccent: '#1E293B',
	baseText: '#F1F5F9',
	border: '#334155',
	mainAreaBg: '#020617',
	mainAreaBgAccent: '#0F172A',
	mainAreaText: '#F1F5F9',
	supportiveText: '#94A3B8',
} as const;

/** Indicador ativo do botão Prontuário na tray do Daily Prebuilt. */
export const PRONTUARIO_TRAY_ACTIVE_COLOR = 'rgb(27, 235, 185)';
